import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchCreate, fetchUpdate, fetchDetail, fetchDelete } from '@/api/otherSystem/banner/banner';
import { getToken } from '@/utils/auth'; // getToken from cookie

import cloneDeep from 'lodash/cloneDeep';
import { fetchListByType } from '@/api/system/dic/dic';
export default _defineProperty({
  data: function data() {
    var _this = this;

    var fileMustUpload = function fileMustUpload(rule, value, callback) {
      console.log(_this.fileList, 'sssss');

      if (_this.fileList.length === 0) {
        // 未上传文件
        callback("请上传照片");
      }

      callback();
    };

    return {
      ruleForm: {
        repairType: '',
        upIdList: '',
        houseId: '',
        situationType: '',
        contact: '',
        phone: '',
        orderType: '',
        orderSubType: '',
        content: '',
        deviceId: ''
      },
      rules: {
        files: [{
          required: true,
          validator: fileMustUpload,
          trigger: 'change'
        }],
        imageId: [{
          required: true,
          message: '请输入图片标签',
          trigger: 'blur'
        }],
        imageInfo: [{
          required: true,
          message: '请输入图片信息',
          trigger: 'blur'
        }],
        fileType: [{
          required: true,
          message: '请选择图片类型',
          trigger: 'change'
        }],
        menuName: [{
          required: true,
          message: '请输入菜单名称',
          trigger: 'blur'
        }]
      },
      buildingId: '',
      uploadUrl: '',
      dialogImageUrl: '',
      imageUrl: '',
      typeRadio: false,
      dialogVisible: false,
      fileList: [],
      options: [],
      addList: [],
      oldImgList: [],
      removeList: [],
      cascaderItem: [],
      buildingOptions: [],
      listObj: {},
      deviceList: [],
      sourceOption: [],
      OrderOption: [],
      degreeOption: [],
      HouseCodeList: [],
      showmatter: true,
      childData: {
        pageUrl: '',
        menuName: '首页轮播图',
        fileType: 1
      },
      typeOption: [],
      documentOption: [],
      isLock: false,
      importHeaders: {
        'access-token': getToken()
      },
      files: [],
      binhai: {},
      binhai2: {},
      delImg: [],
      changeFileList: [],
      typeOptions: []
    };
  },
  props: ['keyValue', 'keyValue1', 'showDialog'],
  created: function created() {
    this.init();
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  methods: {
    loadTypes: function loadTypes() {
      var _this2 = this;

      fetchListByType('applet_file_type').then(function (r) {
        _this2.typeOptions = [];
        _this2.typeOptions = r.data.data;
      });
    },
    init: function init() {
      var _this3 = this;

      this.isLock = false;
      this.files = [];
      this.binhai = {};
      this.buildingId = '';
      this.typeRadio = false;
      this.fileList = [];
      this.addList = [];
      this.removeList = [];
      this.listObj = {};
      this.cascaderItem = [];
      this.loadTypes();
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        this.typeRadio = true;
        var queryData = {
          imageId: this.keyValue1
        };
        this.binhai = {};
        fetchDetail(queryData).then(function (response) {
          _this3.childData = response.data.data;
          _this3.binhai2 = cloneDeep(response.data.data);

          if (_this3.childData.files !== null) {
            _this3.childData.files.forEach(function (item) {
              var imgData = {
                fileId: item.filePath,
                fileType: 2,
                id: item.id,
                imgPath: item.filePath,
                imgId: item.url,
                url: _this3.downloadUrl + item.url,
                fileName: item.fileName
              };

              _this3.fileList.push(imgData);
            });

            _this3.files = cloneDeep(_this3.fileList);
          }
        });
      } else {
        this.deviceList = [];
        this.childData = {
          pageUrl: '',
          menuName: '首页轮播图',
          fileType: 1
        };
      }
    },
    handlePreview: function handlePreview(file) {
      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].failId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.fileType === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: '最多只能上传1个文件!',
        type: 'danger'
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    handCreate: function handCreate() {
      var _this4 = this;

      console.log(this.childData);
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          console.log(_this4.childData);

          if (!_this4.isLock) {
            _this4.isLock = true;

            if (_this4.keyValue > 0) {
              // delete this.childData.upIdList
              delete _this4.childData.opDate; // this.addList = this.addList.map((item) => {
              //   var picUrl = {}
              //   var startIndex = item.url.indexOf('/ibms')
              //   picUrl.url = item.url.split('').splice(startIndex).join('')
              //   return picUrl
              // })

              console.log(_this4.childData.files, '00000000s');
              console.log(_this4.binhai, '00000000s');
              _this4.childData.id = _this4.keyValue;

              if (_this4.binhai.fileId) {
                console.log('11', _this4.binhai); // this.childData.addFiles = [this.binhai]

                _this4.childData.addFiles = [{
                  fileName: _this4.binhai.filePath + _this4.binhai.fileUrl,
                  fileType: '2',
                  url: _this4.binhai.fileId
                }];
              } else {
                console.log('22', _this4.files); // this.childData.addFiles = this.files

                _this4.childData.addFiles = [{
                  fileName: _this4.files[0].fileName,
                  fileType: '2',
                  url: _this4.files[0].imgId
                }];
              }

              fetchUpdate(_this4.childData).then(function (res) {
                if (res.data.code === 200) {
                  _this4.$emit('handCancle', true);

                  _this4.Alert({
                    alertType: 'update'
                  });
                } else {
                  console.log(_this4.binhai2, 'this.binhai2');
                  _this4.childData.files = [{
                    fileName: _this4.binhai2.filePath + _this4.binhai2.files[0].fileUrl,
                    fileType: '2',
                    url: _this4.binhai2.files[0].fileId
                  }];
                  _this4.childData.imageId = _this4.binhai2.imageId;
                  _this4.childData.imageInfo = _this4.binhai2.imageInfo;
                  _this4.childData.menuName = _this4.binhai2.menuName;
                  _this4.childData.pageUrl = _this4.binhai2.pageUrl;
                }

                _this4.isLock = false;
              }).catch(function (err) {
                _this4.isLock = false;
              });
            } else {
              // delete this.childData.upIdList
              console.log(_this4.childData, ';;;;'); // this.childData.url = this.childData.pageUrl

              var listQuery = {
                addFiles: [{
                  fileName: _this4.binhai.filePath + _this4.binhai.fileUrl,
                  // fileId: this.binhai.fileId,
                  fileType: '2',
                  url: _this4.binhai.fileId
                }]
              };
              listQuery.imageId = _this4.childData.imageId;
              listQuery.imageInfo = _this4.childData.imageInfo;
              listQuery.menuName = _this4.childData.menuName;
              listQuery.pageUrl = _this4.childData.pageUrl;
              listQuery.fileType = _this4.childData.fileType;
              fetchCreate(listQuery).then(function (res) {
                if (res.data.code === 200) {
                  _this4.$emit('handCancle', true);

                  _this4.Alert({
                    alertType: 'add'
                  });
                }

                _this4.isLock = false;
              }).catch(function (err) {
                _this4.Alert({
                  alertType: 'error',
                  message: '图片标签重复'
                });
              });
            }
          }
        } else {
          _this4.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairAdd');
    },
    // 获取报修类型
    // loadTypeOptions() {
    //   fetchListByType('repair_type').then(r => {
    //     this.typeOption = r.data.data
    //   })
    // },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      var _this5 = this;

      console.log(response.data[0], ',,,,,', file);
      this.binhai = response.data[0];
      this.addList.push({
        url: response.data.fileName
      });
      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);

      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].name === uid) {
          this.listObj[objKeyArr[i]].url = response.data.fileName;
        }
      }

      this.fileList = Object.keys(this.listObj).map(function (item) {
        return _this5.listObj[item];
      });
    },
    beforeUpload: function beforeUpload(file) {
      var _this6 = this;

      var isLt2M = file.size / 1024 / 1024 < 1;

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 1MB!',
          type: 'error'
        });
        return false;
      }

      var fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise(function (resolve, reject) {
        _this6.listObj[fileName] = {
          name: file.uid
        };
        resolve(true);
      });
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this7 = this;

      this.binhai = [];
      var currentUrl = 0; // 获取当前删除文件的fileId

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
        console.log('file', file);
      } else {
        // 文件是旧数据
        currentUrl = file.fileId;
        this.delImg.push(file.imgId);
      }

      this.files.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.files.splice(index, 1);

          return;
        }
      });
      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.fileList.splice(index, 1);

          console.log('file', file);
          return;
        }
      });
      this.changeFileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.changeFileList.splice(index, 1);

          console.log('file', _this7.changeFileList);
          return;
        }
      });
    },
    // 图片预览
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeTowardValue: function changeTowardValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.userCardType === val;
      });
      this.childData.userCardType = obj.dicName;
    }
  }
}, "watch", {
  showDialog: function showDialog(n, o) {
    if (n) {
      this.$refs.dataForm.resetFields();
      this.init();
    }
  }
});